'use client';
import { TYPE_BIKE } from '@/helpers/constants';
import { isVehicleType } from '@/helpers/utils';
import { useGeneralStore } from '@/providers/general-store-provider';
import { clsx } from 'clsx';
import { useLocalStore } from '../local.context';
import Tabs from '../tabs/tabs.component';
import './content.scss';

export default function Content() {
    const { vehicleType } = useGeneralStore();
    const { title, initialSelections } = useLocalStore();

    const isCar = isVehicleType(vehicleType, 'car');

    const isModelPage = initialSelections?.brand && vehicleType !== TYPE_BIKE && !initialSelections.year;
    const isVersionPageCar = isCar && initialSelections?.year && !initialSelections.state;
    const isVersionPageBike = !isCar && initialSelections?.year && !initialSelections.state;
    const isHomePage = !initialSelections?.brand;

    const containerClass = clsx(
        'container-filter',
        vehicleType === TYPE_BIKE && 'bike',
        isVersionPageCar && 'version-page',
        isVersionPageBike && 'version-page-bike',
        isHomePage && 'home-page',
        isModelPage && 'model-page',
    );

    return (
        <div className={containerClass} data-testid="container-filter" id="container-filter">
            <h2 className="container-filter-title" data-testid="container-filter-title" id="container-filter-title">
                {title ? title : 'Selecione o tipo de veículo'}
            </h2>

            <Tabs />
        </div>
    );
}
